
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Insgesamt starben von den bis am 24. März in Südkorea 9037 Erkrankten
  120 Personen – das entspricht einer Sterblichkeitsrate von 1.3%. In
  China waren es von den in der Studie erfassten 44’672 Erkrankten 1023
  Personen – also eine Sterblichkeit von 2,3%. In Italien beträgt die
  Sterblichkeitsrate der bestätigten Fälle sogar 8.5%. Ein möglicher Grund
  könnte für die hohe Rate sein: Italiens Bevölkerung gehört zu den
  betagtesten der Welt, das Durchschnittsalter liegt bei 46,3 Jahren.
  22 Prozent der Italiener sind über 65 Jahre alt. Zudem: Experten denken,
  dass es in Italien sehr viel mehr Infizierte gibt, als es offizielle
  Statistiken ausweisen.
    </p>
    <p>
  Möglicherweise hänge die geringere Sterberate in Südkorea mit der frühen Erkennung
  der Erkrankten und somit frühen Behandlung zusammen, sagt Kim Dong-hyun, Präsident der
  Koreanischen Gesellschaft für Epidemiologie. Auch die Altersstruktur
  dürfte sicher eine Rolle spielen, da in Südkorea im Vergleich auch zu Italien
  viele jüngere Menschen infiziert sind.
    </p>
    <p>
  Sowohl in Italien als auch Südkorea gab es unter den 0- bis 19-Jährigen keine
  Todesfälle - in China starb in dieser Alterskategorie eine Person. 81% der
  Covid-19-Toten waren in China über 60 Jahre alt, in Südkorea waren es 91.6%,
  in Italien 96.1%.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;